import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CampaignsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Campaigns",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M25.72 19.65 21.46 6.22a.9.9 0 0 0-1.13-.58c-.06.02-.12.04-.17.07L1.46 16.45c-.37.21-.54.65-.42 1.06l1.5 4.71c.13.41.53.67.95.62l3.48-.38c.32 2.4 2.16 4.14 4.13 3.92s3.37-2.32 3.16-4.72l10.71-.86c.49-.05.84-.49.79-.98 0-.06-.02-.12-.04-.17m-14.8 5.15c-1.21.14-2.34-.96-2.56-2.46l4.51-.5c.12 1.48-.74 2.78-1.95 2.95Zm15.4-12.34a.74.74 0 0 1-.75-.74c0-.33.21-.62.53-.72l3.94-1.24c.4-.12.81.1.94.5s-.1.81-.5.94l-3.94 1.22a.9.9 0 0 1-.22.04m-1.7-2.27c-.17 0-.33-.06-.46-.16a.747.747 0 0 1-.11-1.05l1.86-2.3a.748.748 0 0 1 1.17.93l-1.86 2.31c-.15.17-.36.27-.58.27Zm4.64 6.02a.8.8 0 0 1-.22 0l-2.77-.93a.745.745 0 0 1 .47-1.41l2.74.89a.742.742 0 0 1-.21 1.45Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M21.8 11.48c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l2.47-2.47a.996.996 0 1 1 1.41 1.41l-2.47 2.47c-.2.2-.45.29-.71.29ZM17.23 9.45c-.09 0-.17-.01-.26-.03-.53-.14-.85-.69-.71-1.22l.93-3.45c.14-.53.69-.85 1.22-.71s.85.69.71 1.22l-.93 3.45c-.12.45-.52.74-.97.74ZM23.82 16.05c-.44 0-.85-.29-.97-.74a.994.994 0 0 1 .71-1.22l3.17-.85c.53-.15 1.08.17 1.22.71s-.17 1.08-.71 1.22l-3.17.85c-.09.02-.17.03-.26.03ZM25 24H14c-.55 0-1-.45-1-1s.45-1 1-1h8.59L8.29 7.7A.996.996 0 1 1 9.7 6.29l16 16c.29.29.37.72.22 1.09S25.4 24 25 24"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9 19c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v5c0 .55-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10 28c-.26 0-.51-.1-.71-.29l-5-5a.996.996 0 0 1 0-1.41l4-4a.996.996 0 0 1 1.41 0l5 5c.39.39.39 1.02 0 1.41l-4 4c-.2.2-.45.29-.71.29Zm-3.59-6L10 25.59 12.59 23 9 19.41z"
      })]
    })
  }));
};